import React from "react";

import { ThemeProvider } from "@mui/material";

import { Select } from "@aclymatepackages/atoms";
import { mergeMainTheme } from "@aclymatepackages/themes";

import ScopeThreeCategoryAvatar from "../../atoms/icons/ScopeThreeCategoryAvatar";

import { scopeThreeSpendBasedCategories } from "../../../helpers/components/scopeThreeCategories";

const ScopeThreeCategorySelect = ({
  scopeThreeCategory = "",
  setScopeThreeCategory,
  ...otherProps
}) => {
  const options = scopeThreeSpendBasedCategories
    .filter(({ selectable }) => selectable)
    .map(({ name: label, scopeThreeCategory: value, subcategory }) => {
      return {
        label,
        value,
        avatar: (
          <ThemeProvider theme={mergeMainTheme}>
            <ScopeThreeCategoryAvatar scopeThreeCategory={value} size="small" />
          </ThemeProvider>
        ),
        style: {
          backgroundColor: subcategory,
          color: "white",
        },
      };
    });

  return (
    <Select
      label="Select Scope 3 Category"
      options={options}
      value={scopeThreeCategory}
      editValue={setScopeThreeCategory}
      valueAvatar={
        <ScopeThreeCategoryAvatar
          scopeThreeCategory={scopeThreeCategory}
          size="small"
        />
      }
      size="small"
      {...otherProps}
      style={{ minWidth: "200px" }}
    />
  );
};
export default ScopeThreeCategorySelect;
